import Head from 'next/head'
import React from 'react'
import styled from 'styled-components'
import { getPublicLayout } from '@public/components/PublicLayout'
import { Box } from 'components/Layout'
import { prepareGetStaticNavigationProps } from 'routes/utils/prepareGetStaticNavigationProps'

const DESCRIPTION =
  'We’ve collected submissions from vendors and service providers, including interior designers, architects, builders and beyond, that are willing and available to help you through your rebuild process. If you find a vendor that fits your needs, please contact them directly using the email listed with their post. All vendors listed are user submitted and not vetted or endorsed by The Expert.'

const Iframe = styled('iframe')`
  width: 100%;
  height: inherit;
`

export const RebuildDirectory = () => (
  <>
    <Head>
      <title>The Expert Rebuild Directory</title>
      <meta name="description" content={DESCRIPTION} />
      <meta name="twitter:description" content={DESCRIPTION} />
      <meta property="og:description" content={DESCRIPTION} />
    </Head>
    <Box
      width="100%"
      height={{ MOBILE: 'calc(100vh - 300px)', TABLET: 'calc(100vh - 150px)' }}
    >
      <Iframe
        className="airtable-embed"
        src="https://airtable.com/embed/appdfyKYPtFIJtzb0/shrxOPtHU23lKJNgf"
        title="airtable form"
      />
    </Box>
  </>
)

export function getStaticProps() {
  return prepareGetStaticNavigationProps()
}

RebuildDirectory.getLayout = (page) =>
  getPublicLayout(page, {
    isFullWidth: true,
  })
